import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/documentNode';
import * as Apollo from '@apollo/client';
import process from 'process';
export type IsAdminOfAnyEnterpriseFragment = (
  { __typename: 'Member' }
  & Pick<
    Types.Member,
    | 'id'
    | 'idEnterprise'
    | 'idEnterprisesAdmin'
    | 'idPremOrgsAdmin'
  >
  & { organizations: Array<(
    { __typename: 'Organization' }
    & Pick<Types.Organization, 'id' | 'idEnterprise'>
  )> }
);

export const IsAdminOfAnyEnterpriseFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'IsAdminOfAnyEnterprise' },
      typeCondition: {
        kind: 'NamedType',
        name: { kind: 'Name', value: 'Member' },
      },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idEnterprise' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'idEnterprisesAdmin' },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'idPremOrgsAdmin' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'organizations' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'idEnterprise' },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode;

interface UseIsAdminOfAnyEnterpriseFragmentOptions
  extends Omit<
    Apollo.UseFragmentOptions<
      IsAdminOfAnyEnterpriseFragment,
      Apollo.OperationVariables
    >,
    'fragment' | 'fragmentName' | 'from'
  > {
  from: Apollo.StoreObject | Apollo.Reference;
  returnPartialData?: boolean;
}

interface UseIsAdminOfAnyEnterpriseFragmentResult
  extends Omit<
    Apollo.UseFragmentResult<IsAdminOfAnyEnterpriseFragment>,
    'data'
  > {
  data?: IsAdminOfAnyEnterpriseFragment;
}

export const useIsAdminOfAnyEnterpriseFragment = ({
  from,
  returnPartialData,
  ...options
}: UseIsAdminOfAnyEnterpriseFragmentOptions): UseIsAdminOfAnyEnterpriseFragmentResult => {
  const result = Apollo.useFragment<IsAdminOfAnyEnterpriseFragment>({
    ...options,
    fragment: IsAdminOfAnyEnterpriseFragmentDoc,
    fragmentName: 'IsAdminOfAnyEnterprise',
    from: {
      __typename: 'Member',
      ...from,
    },
  });

  // Ensure that the fragment result is not typed as a DeepPartial.
  if (!result.complete && !returnPartialData) {
    if (process.env.NODE_ENV === 'development') {
      if (
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === 'false' ||
        localStorage.getItem('HIDE_FRAGMENT_WARNINGS') === null
      ) {
        console.warn('Fragment data is incomplete.', result);
      }
    }
    return {
      ...result,
      data: undefined,
    };
  }

  return { ...result, data: result.data as IsAdminOfAnyEnterpriseFragment };
};
